import {User} from 'projects/core/src/lib/login/data/user';
import {AbstractModel, JsonObject, JsonProperty, DateConverter} from 'projects/core/src/public-api';
import {Project} from '../project';

@JsonObject('model.activity.ActivityInitData')
export class ActivityInitData extends AbstractModel {

  @JsonProperty(Number, 'duration')
  duration: number;

  @JsonProperty(Number, 'durationWA')
  durationWA: number;

  @JsonProperty(Number, 'typeDayDuration')
  typeDayDuration: number;

  @JsonProperty(Boolean, 'ignoreTime')
  ignoreTime?: boolean;

  @JsonProperty(Boolean, 'isQtyLimitExceeded')
  isQtyLimitExceeded?: boolean;

  @JsonProperty(DateConverter, 'startDate')
  startDate?: Date;

  @JsonProperty(DateConverter, 'startDateByWorkload')
  startDateByWorkload?: Date;// using workload calculation

  @JsonProperty([User], 'users')
  users?: User[];
}
